<template>
  <v-container class="pa-0" id="wizard-poistenie">
    <v-form v-model="formValid" ref="form" autocomplete="off">
      <!-- <v-overlay :absolute="true" :value="showOverlay" :z-index="3">
        <v-progress-circular
          indeterminate
          color="primary"
          :size="60"
          :width="5"
          class="mr-10px"
        />
        Prebieha načítanie dát, prosím počkajte ...
      </v-overlay> -->
      <template >
        <v-dialog
          v-model="olfsPripoistenieDialog"
          overlay-color="#000"
          overlay-opacity="0.66"
          persistent
          eager
          max-width="900"
        >
          <v-card class="dialog-card">
            <v-card-title class="d-flex justify-space-between dialog-title-close">
              <span>
                Zvoľte pripoistenie
              </span>
            </v-card-title>
            <v-card-text>
              <pripoistenie-control jeOlfs ref="olfs_pripoistenie" :zamknuty="pripad.predmetZamknuty" :isMobile="isMobile" :cisloPredmetu="pripad.cisloPredmetu" @valueChanged="changePoistenie($refs.olfs_pripoistenie)"/>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="btn-primary" @click="savePripoistenie(true)"> Uložiť </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <h1 v-if="!isMobile" v-show="pripad.jeOlfs" :class="[{
                      'mt-16px': isMobile,
                      'mt-45px': !isMobile,
                      'mb-28px': !isMobile
                    }]"
            style="display: flex">
          <span> Poistenie pre operatívny leasing </span>
          <div class="wizard-header-info" :class="[{'ml-0px': isMobile}]">
            <span :class="[{'pl-4': isMobile}]">Je zahrnuté v celkovej mesačnej splátke.</span>
          </div>
        </h1>

        <v-row v-show="pripad.jeOlfs && olfsShow" class="no-padding-top-bottom">
          <v-col>
            <v-card class="card" :class="[{'mb-0px': isMobile}]">
              <template v-if="isMobile">
                <v-row :class="[{'mb-10px': isMobile}]">
                  <v-col cols="9">
                    <h2 :class="{ 'mobile-item-picked-icon' : isMobile && olfsItemPicked && !olfsItemsShow}">Operatívny leasing</h2>              
                  </v-col>
                </v-row>
                <v-row :class="[{'mb-10px': !isMobile || olfsItemsShow}]">
                  <v-col>
                    <span class="gs100">
                      Poistene pre operatívny leasing je zahrnuté v celkovej mesačnej splátke.
                    </span>
                  </v-col>
                </v-row>
              </template>
              
              <poistenie-control
                v-show="olfsItemsShow"
                data-id="liw_filip__wiz_poistenie__cb_poistenie_olfs"
                :cisloPredmetu="pripad.cisloPredmetu"
                @itemIsPicked="(val) => olfsItemPicked = val"
                @showPoistenieControl="(val) => olfsItemsShow = val"
                @addButtonClicked="addButtonClicked"
                @dataLoadedAndLoading="loadedOlfs"
                :preventUnselectWhenSingle="true"
                add-button
                ref="olfs"
                isOlfs
                @valueChanged="changePoistenie($refs.olfs)"
                @show="(val) => (olfsShow = val)"
              />
            </v-card>
          </v-col>
        </v-row>
        
      </template>
      <h1 v-show="existujuData" :class="[{
                      'mt-16px': isMobile,
                      'mt-45px': !isMobile,
                      'mb-28px': !isMobile
                    }]"
          style="display: flex">
        <span v-if="!isMobile"> {{ poistenieTitle }} </span>
        <div class="wizard-header-info" :class="[{'ml-0px': isMobile}]">
          <span :class="[{'pl-4': isMobile}]">Cena poistenia sa odvíja od vami zadaných údajov o predmete.</span>
        </div>
      </h1>
      <debug-control
        v-if="debug"
        @click="log"
        :value="[
          'validationObjectResult',
          'formValid',
          'somethingGetDirty',
          'currentControl',
          'somethingIsLoading',
        ]"
        :parent="this"
      />

      <!-- <v-dialog
        v-model="warningMessage.open"
        overlay-color="#000"
        overlay-opacity="0.66"
        persistent
        eager
        max-width="500"
      >
        <v-card>
          <v-card-title class="d-flex justify-space-between">
            <span class="gs100 f16">Upozornenie</span>
            <v-btn icon @click="warningMessage.open = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="f16 white100">
            {{ warningMessage.text }}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="btn-secondary" @click="warningMessage.open = false"> Späť </v-btn>
            <v-btn class="btn-primary" @click="warningMessage.action()"> Pokračovať </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog> -->

      <v-dialog
        v-model="pripoistenieDialog"
        overlay-color="#000"
        overlay-opacity="0.66"
        persistent
        eager
        max-width="900"
      >
        <v-card class="dialog-card">
          <v-card-title class="d-flex justify-space-between dialog-title-close">
            <span>
              Zvoľte pripoistenie
            </span>
            <v-btn icon @click="closePripoistenie()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <pripoistenie-control ref="kasko_pripoistenie" :zamknuty="pripad.predmetZamknuty" :isMobile="isMobile" :cisloPredmetu="pripad.cisloPredmetu" @valueChanged="changePoistenie($refs.kasko_pripoistenie)"/>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="btn-primary" @click="savePripoistenie()"> Uložiť </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- <v-dialog
        v-model="detailDialog"
        overlay-color="#000"
        overlay-opacity="0.66"
        persistent
        eager
        max-width="576"
      >
        <v-card class="dialog-card pripoistenie">
          <v-card-title class="d-flex justify-space-between">
            Detail poistenia
            <v-btn icon @click="detailDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <span class="detail-header">Názov tejto balíkovej šablóny</span>
            <span>{{ detailMessage }}</span>
            <v-row v-for="(datum, i) in detailData" :key="i">
              <v-col cols="7" class="py-2 detail-name">{{ datum.popis }}</v-col>
              <v-col cols="5" class="py-2 detail-value">{{ datum.hodnota }}</v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog> -->
      <v-row v-show="akciovePonukyShow" class="no-padding-top-bottom">
        <v-col>
          <v-card class="card" :class="[{'mb-0px': isMobile}]">
            <v-row :class="[{'mb-10px': isMobile}]">
              <v-col cols="9">
                <h2 :class="{ 'mobile-item-picked-icon' : isMobile && akciovePonukyItemsPicked && !akciovePonukyItemsShow}">Akciové ponuky</h2>
              </v-col>
              <v-col 
                v-if="isMobile">
                <v-btn
                  @click="$refs.akcia.changeItemsShow(akciovePonukyItemsShow)"
                  style="min-width: 38px"
                  class="pa-0 btn-secondary right"
                >
                  <v-icon :class="{'rotate-180': akciovePonukyItemsShow}">mdi-chevron-down</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <poistenie-control
              v-show="akciovePonukyItemsShow"
              :banner="!isMobile"
              data-id="liw_filip__wiz_poistenie__cb_poistenie_akcia"
              :cisloPredmetu="pripad.cisloPredmetu"
              @itemIsPicked="(val) => akciovePonukyItemsPicked = val"
              @showPoistenieControl="(val) => akciovePonukyItemsShow = val"
              @addButtonClicked="addButtonClicked"
              add-button
              ref="akcia"
              @valueChanged="changePoistenie($refs.akcia)"
              @dataLoadedStateChanged="onAkciaDataLoadedStateChanged"
              @show="(val) => (akciovePonukyShow = val)"
            />
          </v-card>
        </v-col>
      </v-row>
      <v-row class="no-padding-top-bottom" :class="{ 'mt-6' : !isMobile }" v-show="vyhodneBalikyShow">
        <v-col>
          <v-card class="card" :class="[{'mb-0px': isMobile}]">
            <v-row :class="[{'mb-10px': isMobile}]">
              <v-col cols="9">
                <h2 :class="{ 'mobile-item-picked-icon' : isMobile && vyhodneBalikyItemPicked && !vyhodneBalikyItemsShow}">Výhodné balíky</h2>              
              </v-col>
              <v-col 
                v-if="isMobile">
                <v-btn
                  @click="$refs.baliky.changeItemsShow(vyhodneBalikyItemsShow)"
                  style="min-width: 38px"
                  class="pa-0 btn-secondary right"
                >
                  <v-icon :class="{'rotate-180': vyhodneBalikyItemsShow}">mdi-chevron-down</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row :class="[{'mb-10px': !isMobile || vyhodneBalikyItemsShow}]">
              <v-col>
                <span class="gs100">
                  Vyberte si balík poistenia a pripoistenie získate za zvýhodnenú cenu.
                </span>
              </v-col>
            </v-row>
            <poistenie-control
              v-show="vyhodneBalikyItemsShow"
              data-id="liw_filip__wiz_poistenie__cb_poistenie_balik"
              :cisloPredmetu="pripad.cisloPredmetu"
              @itemIsPicked="(val) => vyhodneBalikyItemPicked = val"
              @showPoistenieControl="(val) => vyhodneBalikyItemsShow = val"
              @addButtonClicked="addButtonClicked"
              add-button
              ref="baliky"
              @valueChanged="changePoistenie($refs.baliky)"
              @dataLoadedStateChanged="onBalikyDataLoadedStateChanged"
              @show="(val) => (vyhodneBalikyShow = val)"
            />
          </v-card>
        </v-col>
      </v-row>
      <v-row class="no-padding-top-bottom" :class="{ 'mt-6' : !isMobile }" id="samostatne-poistne-sadzby" v-show="samostatneSadzbyShow">
        <v-col>
          <v-card class="card">
            <h2>Samostatné poistné sadzby</h2>
            <v-expansion-panels class="wizard-expansion-panels" accordion multiple flat v-model="sadzbyPanel"> 
              <v-expansion-panel @change="$refs.kasko.loadData()" v-show="kaskoShow">
                <v-expansion-panel-header class="pa-0">
                  <span :class="{ 'mobile-item-picked-icon-sadzby' : isMobile && kaskoPicked && !this.isSadzbaOpen(0)}" v-if="pripad.jeTechnologia"> Strojné poistenie </span>
                  <span :class="{ 'mobile-item-picked-icon-sadzby' : isMobile && kaskoPicked && !this.isSadzbaOpen(0)}" v-if="!pripad.jeTechnologia"> Havarijné poistenie </span>
                </v-expansion-panel-header>
                <v-expansion-panel-content eager class="mt-12px">
                  <poistenie-control
                    ignore-init
                    data-id="liw_filip__wiz_poistenie__cb_poistenie_kasko"
                    :cisloPredmetu="pripad.cisloPredmetu"
                    @itemIsPicked="(val) => kaskoPicked = val"
                    @addButtonClicked="addButtonClicked"
                    add-button
                    ref="kasko"
                    @valueChanged="changePoistenie($refs.kasko)"
                    @dataLoadedStateChanged="onKaskoDataLoadedStateChanged"
                    @show="(val) => (kaskoShow = val)"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel @change="$refs.pzp.loadData()" v-show="pzpShow">
                <v-expansion-panel-header class="pa-0">
                  <span :class="{ 'mobile-item-picked-icon-sadzby' : isMobile && pzpPicked && !this.isSadzbaOpen(1)}">
                    Povinné zmluvné poistenie
                  </span>
                </v-expansion-panel-header>
                <v-expansion-panel-content eager class="mt-12px">
                  <poistenie-control
                    ignore-init
                    data-id="liw_filip__wiz_poistenie__cb_poistenie_pzp"
                    :cisloPredmetu="pripad.cisloPredmetu"
                    @itemIsPicked="(val) => pzpPicked = val"
                    ref="pzp"
                    @valueChanged="changePoistenie($refs.pzp)"
                    @show="(val) => (pzpShow = val)"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel @change="$refs.gap.loadData()" v-show="gapShow">
                <v-expansion-panel-header class="pa-0">
                  <span :class="{ 'mobile-item-picked-icon-sadzby' : isMobile && gapPicked && !this.isSadzbaOpen(2)}">
                    Poistenie finančnej straty
                  </span>
                </v-expansion-panel-header>
                <v-expansion-panel-content eager class="mt-12px">
                  <poistenie-control
                    ignore-init
                    data-id="liw_filip__wiz_poistenie__cb_poistenie_fs"
                    :cisloPredmetu="pripad.cisloPredmetu"
                    @itemIsPicked="(val) => gapPicked = val"
                    ref="gap"
                    @valueChanged="changePoistenie($refs.gap)"
                    @show="(val) => (gapShow = val)"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>
<script>
import PoistenieBanner from '../poistenie/PoistenieBanner';
import PoistenieControl from '../poistenie/PoistenieControl.vue';
import { wizardMixin } from '../../mixins/wizardMixin.js';
import PripoistenieControl from '../poistenie/PripoistenieControl.vue';
import protectedAxios from '../../auth/axios';
import { mapState, mapGetters, mapMutations } from 'vuex';

export default {
  mixins: [wizardMixin],
  components: {
    PoistenieBanner,
    PoistenieControl,
    PripoistenieControl,
  },
  data() {
    return {
      defaultMessage: {
        text: '',
        isError: false,
      },
      isRequiredComponent: null,
      pripoistenieDialog: false,
      warningMessage: {
        open: false,
        text: '',
        shown: false,
        action: () => {},
      },
      data: [],
      olfsShow: false,
      olfsItemsShow: true,
      olfsItemPicked: true,
      olfsPripoistenieDialog:false,
      akciovePonukyShow: false,
      akciovePonukyItemsShow: true,
      akciovePonukyItemsPicked: true,
      vyhodneBalikyShow: false,
      vyhodneBalikyItemsShow: true,
      vyhodneBalikyItemPicked: true,
      kaskoShow: false,
      kaskoPicked: false,
      pzpShow: false,
      pzpPicked: false,
      gapShow: false,
      gapPicked: false,
      sadzbyPanel: undefined,
      hasKaskoData: false,
      hasAkciaData: false,
      hasBalikyData: false,
      // detailDialog: false,
      // detailMessage: '',
      // detailData: [],
    };
  },
  watch: {
    pripoistenieDialog(val) {
      //if (val === true) this.$refs.kasko_pripoistenie.loadData();
    },
    sadzbyPanel(newVal, oldVal){
      if(newVal != undefined && oldVal != undefined){
        let oldItem = oldVal.filter(item => !newVal.includes(item));
        let newItem = newVal.filter(item => !oldVal.includes(item));
        if(oldItem.length){
          switch(oldItem[0]){
            case 0: this.$refs.kasko.changeItemsShow(false)
            break;
            case 1: this.$refs.pzp.changeItemsShow(false)
            break;
            case 2: this.$refs.gap.changeItemsShow(false)
            break;
          }
        }
        if(newItem.length){
          switch(newItem[0]){
            case 0: this.$refs.kasko.changeItemsShow(true)
            break;
            case 1: this.$refs.pzp.changeItemsShow(true)
            break;
            case 2: this.$refs.gap.changeItemsShow(true)
            break;
          }
        }
      }
    }
  },
  computed: {
    ...mapState(['pripad']),
    ...mapGetters(['debug', 'dialog', 'isMobile']),
    samostatneSadzbyShow() {
      return this.kaskoShow || this.pzpShow || this.gapShow;
    },
    existujuData(){
      let existujuData = this.hasKaskoData || this.hasAkciaData || this.hasBalikyData;
      if(!existujuData && this.pripad.jeOlfs){
        return false;
      } 
      return true;
    },
    poistenieTitle(){
      return this.pripad.jeOlfs ? 'Poistenie pre ostatné produkty' : this.title
    }
  },
  methods: {
    ...mapMutations(['openDialog', 'closeDialog']),
    onBalikyDataLoadedStateChanged(hasData) {
      this.hasBalikyData = hasData;
    },
    onKaskoDataLoadedStateChanged(hasData) {
      this.hasKaskoData = hasData;
    },
    onAkciaDataLoadedStateChanged(hasData) {
      this.hasAkciaData = hasData;
    },
    addButtonClicked(val) {
      if (
        val === this.$refs.kasko.getValue() ||
        val === this.$refs.akcia.getValue() ||
        val === this.$refs.baliky.getValue()
      ) {
        this.$refs.kasko_pripoistenie.loadData().then(() => {
          this.pripoistenieDialog = true;
        });
      }
      if (
        val === this.$refs.olfs.getValue()
      ) {
        this.$refs.olfs_pripoistenie.loadData().then(() => {
          this.olfsPripoistenieDialog = true;
        });
      }
    },
    savePripoistenie(jeOlfs = false) {
      if(jeOlfs){
        if (this.$refs.olfs_pripoistenie.checkValidate()) {
          this.olfsPripoistenieDialog = false;
          this.$refs.olfs_pripoistenie.saveValue(this.$refs.olfs_pripoistenie.getValue());
        }
      }else{
        if (this.$refs.kasko_pripoistenie.checkValidate()) {
          this.pripoistenieDialog = false;
          this.$refs.kasko_pripoistenie.saveValue(this.$refs.kasko_pripoistenie.getValue());
        }
      }
    },
    closePripoistenie() {
      if (this.isRequiredComponent) {
        this.isRequiredComponent.update(null);
      }
      this.pripoistenieDialog = false;
    },
    changePoistenie(control){
      //console.log("changePoistenie", control.l_dataId);
      if(control){
        control.loadData();
        let controlsForRefresh = [];
        for (const property in this.$refs) {
          if (control !== this.$refs[property]) {
            controlsForRefresh.push(this.$refs[property]);
          }
        }
          controlsForRefresh.forEach(element => {
            if (typeof element.loadData === 'function') {
              if (element === this.$refs.kasko_pripoistenie) {
                element.loadData().then(() => {
                  if (!element.checkAllSetData()) {
                    this.pripoistenieDialog = true;
                    this.isRequiredComponent = control;
                  } else {
                    this.isRequiredComponent = null;
                  }
                });
              }else if(element === this.$refs.olfs_pripoistenie){
                element.loadData().then(() => {
                  if (!element.checkAllSetData()) {
                    this.olfsPripoistenieDialog = true;
                    this.isRequiredComponent = control;
                  } else {
                    this.isRequiredComponent = null;
                  }
                });   
              }else {
                element.loadData();
              }
            }
          });
      }
    },
    isSadzbaOpen(index){
      return this.sadzbyPanel?.filter(x => x == index).length > 0
    },
    loadedOlfs(){
      // console.log(this.$refs.olfs.l_value == null || this.$refs.olfs.l_value == "");
      if((this.$refs.olfs.l_value == null || this.$refs.olfs.l_value == "") && this.$refs.olfs.data.length > 0){
        let value = this.$refs.olfs.data[0].valueMember;
        this.$refs.olfs.update(value);
        // this.$nextTick(()=>{
        //   this.addButtonClicked(value);
        // })
      }
    },
    reload() {
      console.log("reload");
      this.changePoistenie(this.$refs.akcia)
    },
    //beforeStep vola PripadyWizard.vue po validacii formulara. Musi vratit promise !!!
    beforeStep() {
      this.clearDirty();
      if (this.dialog.value) {
        return Promise.resolve(true);
      }
      if(this.existujuData){
        return protectedAxios
        .get('/poistenie/warningmessage')
        .then(res => {
          if (res.data) {
            let _dialog = {
              persistent: true,
              header: `<span class="gs100 f16">Upozornenie</span>`,
              closeIcon: {
                value: true,
                func: null
              },
              text: `<span class="f16 white100">${res.data} </span>`,
              primaryBtn: {
                text: `Pokračovať`,
                func: null,
              },
              secondaryBtn: {
                text: `Späť`,
                func: null,
              },
            };

            // this.warningMessage.shown = true;
            // this.warningMessage.text = res.data;
            // this.warningMessage.open = true;
            return new Promise((res, rej) => {
              _dialog.primaryBtn.func = () => {
                this.closeDialog();
                res(true);
              };
              _dialog.secondaryBtn.func = () => {
                this.closeDialog();
                res(false);
              };
              _dialog.closeIcon.func = () => {
                this.closeDialog();
                res(false);
              };

              
              this.openDialog(_dialog);
              // this.warningMessage.action = () => {
              //   this.warningMessage.open = false;
              //   res(true);
              // };
            });
          }

          return true;
        })
        .catch(e => {
          console.log(e);
          return Promise.resolve(false);
        });
      }else{
        return Promise.resolve(true);
      }
      
    },
  },
  created() {
    if (this.isMobile) {
      this.akciovePonukyItemsShow = false;
      this.vyhodneBalikyItemsShow = false;
    }
  }
};
</script>
